
export default {
  name: 'MoleculeContentBlockImage',
  props: {
    contentBlock: {
      required: true,
      type: Object,
      default: function () {
        return {}
      }
    },
    presentationData: {
      required: true,
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    cdnBase() {
      return this.$store.getters['base/cdnBase']
    },
    clientName() {
      return this.$config.CLIENT
    },
    presentationDataUuid() {
      return this.presentationData?.uuid
    }
  },
  methods: {}
}
